export default __webpack_public_path__ + "fonts/right-arrow-Last.svg";